/** Fecha de hoy (o de `d`) como "yyyy-MM-dd" en la zona del navegador. `toISOString()` da la fecha UTC, que de noche ya es "mañana" en México. */
export function localIsoDate(d: Date = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
